import { parse, stringify } from 'qs';

const addScpParameterToUrl = (url: string): string => {
  const search = typeof window !== 'undefined' ? window.location.search : '';

  const locationSearch = parse(search, { ignoreQueryPrefix: true });
  const urlParts = url.split('?');
  const path = urlParts[0];
  const query = urlParts[1] ? parse(urlParts[1]) : {};

  let updatedQuery = { ...query };
  if (locationSearch.scp) {
    updatedQuery = { ...updatedQuery, ...locationSearch };
  }

  const updatedQueryString = stringify(updatedQuery);

  return Object.keys(updatedQuery).length ? `${path}?${updatedQueryString}` : path;
};

export default addScpParameterToUrl;
